import {
  trigger,
  animate,
  style,
  group,
  query,
  transition,
  AnimationMetadata
} from '@angular/animations';


function slideTo(direction: 'left' | 'right'): AnimationMetadata[] {
  const enterFrom = direction === 'left' ? '100%' : '-100%';
  const leaveTo = direction === 'left' ? '-100%' : '100%';

  return [
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      })
    ], { optional: true }),

    group([
      query(':enter', [
        style({ transform: `translateX(${enterFrom})` }),
        animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' }))
      ], { optional: true }),

      query(':leave', [
        style({ transform: 'translateX(0%)' }),
        animate('0.5s ease-in-out', style({ transform: `translateX(${leaveTo})` }))
      ], { optional: true })
    ])
  ];
}

export const routerTransition = trigger('routerTransition', [
  transition('forward => *', slideTo('left')),
  transition('backward => *', slideTo('right')),
]);
